import { fontWeights } from "@/utils/fonts";
import AllIconsComponent from "../custom-icons/AllIconsComponent";

export interface DataAnalysisItem {
  title: string;
  imgSrc: string;
  iconHeight?: string;
  iconWidth?: string;
}

export interface DataAnalysisProps {
  title?: string;
  items?: DataAnalysisItem[];
  locationName?: string;
  serviceName?: string;
}

export function DataStructureAndAnalysis({
  title,
  items = [],
  locationName,
  serviceName
}: DataAnalysisProps) {
  const replaceDynamicPlaceholders = (text: string | undefined) => {
    if (!text) return "";
    return text
      .replace(/{location}/g, locationName || "")
      .replace(/{service}/g, serviceName || "");
  };

  const displayItems = items || [];
  const finalTitle = replaceDynamicPlaceholders(title);

  const firstGroup = displayItems.slice(0, 3);
  const secondGroup = displayItems.slice(3, 5);

  return (
    <section>
      <div className="mx-auto max-w-[1920px] max-h-auto px-4">
        <h2
          className="
        text-[24px] 
        lg:text-[35px]
        2xl:text-[40px] 
        3xl:text-[45px] 
        text-center 
        mb-[20px]
        sm:mb-[40px]
        lg:mb-[50px]
        xl:mb-[80px]
        2xl:mb-[116px]
        text-[#000000]
                   "
          style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.bold }}
          dangerouslySetInnerHTML={{ __html: finalTitle }}
        />
        <div className="max-w-[1285px] max-h-auto  mx-auto  ">
          <div className="flex flex-wrap justify-center gap-[20px] sm:gap-[30px] lg:gap-[45px] xl:gap-[60px]">
            {/* Group 1: First 3 items */}
            <div className="flex flex-wrap justify-center gap-[20px] sm:gap-[30px] lg:gap-[45px] xl:gap-[60px]">
              {firstGroup.map((work, index) => (
                <div key={`group1-${index}`} className="text-center flex-shrink-0">
                  <div className="mx-auto h-[90px] w-[90px] sm:h-[120px] sm:w-[120px] lg:h-[150px] lg:w-[150px] xl:h-[195px] xl:w-[195px] bg-[#FFE9CC] flex items-center justify-center rounded-full border-2 border-[#EEB04D] [&>svg]:max-w-[55%] [&>svg]:max-h-[55%] [&>svg]:w-auto [&>svg]:h-auto">
                    <AllIconsComponent iconName={work.imgSrc} height="100%" width="100%" color="" />
                  </div>
                  <h3 className="text-[16px] sm:text-[20px] lg:text-[25px] xl:text-[30px] tsm-400:mb-4 md:mb-8 mt-2 sm:mt-4 text-[#002F6D] mb-5 tsm-400:mb-0" style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}  >
                    {replaceDynamicPlaceholders(work.title)}
                  </h3>
                </div>
              ))}
            </div>

            {/* Group 2: Remaining 2 items */}
            <div className="flex flex-wrap justify-center gap-[20px] sm:gap-[30px] lg:gap-[45px] xl:gap-[60px]">
              {secondGroup.map((work, index) => (
                <div key={`group2-${index}`} className="text-center flex-shrink-0">
                  <div className="mx-auto h-[90px] w-[90px] sm:h-[120px] sm:w-[120px] lg:h-[150px] lg:w-[150px] xl:h-[195px] xl:w-[195px] bg-[#FFE9CC] flex items-center justify-center rounded-full border-2 border-[#EEB04D] [&>svg]:max-w-[55%] [&>svg]:max-h-[55%] [&>svg]:w-auto [&>svg]:h-auto">
                    <AllIconsComponent iconName={work.imgSrc} height="100%" width="100%" color="" />
                  </div>
                  <h3 className="text-[16px] sm:text-[20px] lg:text-[25px] xl:text-[30px] tsm-400:mb-4 md:mb-8 mt-2 sm:mt-4 text-[#002F6D] mb-5 tsm-400:mb-0" style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}  >
                    {replaceDynamicPlaceholders(work.title)}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className="
          py-[20px]
          sm:py-[30px]
          lg:py-[40px]
          2xl:py-[60px] 
          bg-white
      "
      >
        <div className="lg:h-[1px] h-[0.95px] lg:w-[200px] w-[150px] bg-[#002F6D] mx-auto" />
      </div>
    </section>
  );
}
